import React, { useState } from "react";
import { Row, Col, Card, Menu, Dropdown, Button } from "antd";

import {
  MdEmail,
  MdPhone,
  MdLocationOn,
  BsThreeDotsVertical,
} from "react-icons/all";
import "./index.css";
import Delete_order from "../../assets/images/delete_order.png";
import CustomModal from "../modals/customModal";
import { useDispatch } from "react-redux";

export default function PlantInfoCard({
  data,
  getAddresses,
  updateAddress,
  filter,
}) {
  const [isOpenModal, setOpenModal] = useState(false);
  const dispatch = useDispatch();
  const menu = (
    <Menu style={{ width: 0, padding: 0 }} className="menu-fit">
      <Menu.Item
        key="0"
        // onClick={
        //   data?.default_source
        //     ? () => {
        //         info(
        //           "error",
        //           "Cannot delete default card! Make any other card your default and then delete this card"
        //         );
        //       }
        //     : () => setOpenModal(true)
        // }
        style={{ marginLeft: "-5px" }}
      >
        <span className="st-primary">Edit</span>
      </Menu.Item>

      <Menu.Item
        key="0"
        onClick={() => setOpenModal(true)}
        // onClick={
        //   data?.default_source
        //     ? () => {
        //         info(
        //           "error",
        //           "Cannot delete default card! Make any other card your default and then delete this card"
        //         );
        //       }
        //     : () => setOpenModal(true)
        // }
        style={{ marginLeft: "-5px" }}
      >
        <span className="st-primary">Delete</span>
      </Menu.Item>
    </Menu>
  );
  return (
    <Row justify="center">
      <Col xs={24} sm={24} md={24} lg={24} xl={24} className="custom">
        <Card style={{ height: "258px" }} className="ant-card-body ">
          <Row justify="space-between" style={{ marginBottom: "20px" }}>
            <Col span={18}>
              <h4 className="text-left">Address</h4>
            </Col>
            <Col span={6}>
              <Dropdown
                overlay={menu}
                trigger={["click"]}
                style={{ width: "40%" }}
              >
                <BsThreeDotsVertical
                  size="20"
                  color="#888888"
                  className="pointer-cursor"
                />
              </Dropdown>
            </Col>
          </Row>
          <Row gutter={[0, 2]} justify="space-between">
            <Col span={4} className="text-right ">
              <MdPhone size="20" color="#888888" />
            </Col>
            <Col span={19}>
              <p className="st-primary text-left m-zero">Phone</p>
              <p className=" text-left three-dot">{data?.phone}</p>
            </Col>
          </Row>
          <Row gutter={[0, 2]} justify="space-between">
            <Col span={4} className="text-right ">
              <MdEmail size="20" color="#888888" />
            </Col>
            <Col span={19}>
              <p className="st-primary text-left m-zero">Email</p>
              <p className=" text-left three-dot">{data?.email}</p>
            </Col>
          </Row>
          <Row gutter={[0, 2]} justify="space-between">
            <Col span={4} className="text-right ">
              <MdLocationOn size="20" color="#888888" />
            </Col>
            <Col span={19}>
              <p className="st-primary text-left m-zero ">Address</p>
              <p className=" text-left three-dot" title={data?.address}>
                {data?.address}
              </p>
            </Col>
          </Row>
        </Card>
      </Col>
      <CustomModal
        visible={isOpenModal}
        onCancelModal={() => setOpenModal(false)}
        footer={[
          <Row justify="center" style={{ margin: "20px" }}>
            <Col
              className="d-flex justify-content-center"
              style={{ width: "100%" }}
            >
              <Button
                style={{
                  backgroundColor: "#ff9800",
                  color: "#fff",
                  width: "30%",
                  border: "none",
                }}
                onClick={() =>
                  dispatch(
                    updateAddress(data.id, "deactivate", {}, () => {
                      getAddresses(filter);
                      setOpenModal(false);
                    })
                  )
                }
              >
                YES
              </Button>
              <Button
                style={{
                  backgroundColor: "#26a69a ",
                  color: "#fff",
                  width: "30%",
                  border: "none",
                }}
                onClick={() => setOpenModal(false)}
              >
                NO
              </Button>
            </Col>
          </Row>,
        ]}
      >
        <Row justify="center">
          <Col className="d-flex justify-content-center" span={24}>
            <img src={Delete_order} />
          </Col>
          <Col span={24} style={{ textAlign: "center" }}>
            <span>{"Are you sure you want to delete this card?"}</span>
          </Col>
        </Row>
      </CustomModal>
    </Row>
  );
}
